<template>
  <div class="flex flex-col items-center mt-3 bg-zt-dark-200">
    <div class="bg-white flex w-full py-2 border-b-2 border-t-2 justify-center">
      <div>
        <div class="flex">
          <div class="pr-2">
            <button
              class="focus:outline-none text-zt-primary-200 text-zt-xl"
              @click="zoomModification('plus')"
            >
              <zt-icon name="zoom-in" />
            </button>
          </div>
          <div>
            <button
              class="focus:outline-none text-zt-primary-200 text-zt-xl"
              @click="zoomModification('minus')"
            >
              <zt-icon name="zoom-out" />
            </button>
          </div>
        </div>
      </div>
      <div class="pl-4">
        <button
          @click="beforePage"
          class="focus:outline-none text-zt-primary-200"
        >
          <zt-icon name="angle-left" />
        </button>
        <p class="inline-block px-1 pt-1 ">{{ page }} / {{ totalPages }}</p>
        <button
          @click="nextPage"
          class="focus:outline-none text-zt-primary-200"
        >
          <zt-icon name="angle-right" />
        </button>
      </div>
    </div>
    <div
      class="w-full overflow-auto"
      :class="classes">
      <div class="w-full border-r-2 border-l-2 border-b-2" style="height: 700px">
        <zt-pdf-viewer
          ref="ztPDFViewer"
          class="mx-auto"
          :src="baseFile"
          :page="page"
          :scale="effectiveScale"
          :show-control="false"
          @page-count="totalPages = $event"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useWindowResize } from '@sichern/ui-elements'
export default {
  data() {
    return {
      page: 1,
      totalPages: 0,
      zoomInitial: 100,
      idContainer: `pdf-container-${this._uid}`,
      windowResize: useWindowResize(this)
    }
  },
  props: ['file'],
  methods: {
    nextPage() {
      if (this.page < this.totalPages) {
        return this.page++
      }

      return null
    },
    beforePage() {
      if (this.page > 1) {
        return this.page--
      }

      return null
    },
    zoomModification(action) {
      if (action === 'plus' && this.zoomInitial < 200) {
        return (this.zoomInitial += 20)
      }
      if (action === 'minus' && this.zoomInitial > 50) {
        this.zoomInitial -= 20
      }
    }
  },
  computed: {
    baseFile() {
      return `data:application/pdf;base64,${this.file}`
    },
    isMobile() {
      return this.windowResize.width < 1024
    },
    classes() {
      if (this.isMobile) {
        return 'main--container-mobile'
      }
      return 'main--container'
    },
    effectiveScale() {
      const baseScale = this.isMobile ? 0.5 : 1.0
      return (this.zoomInitial / 100) * baseScale
    }
  }
}
</script>

<style scoped>
.main--container {
  max-height: 1024px;
}
.main--container-mobile {
  max-height: calc(65vh - 52px);
}
</style>
